<ng-container>
    <div class="evento-container">
        <div class="evento-header">
            <div>
                <h4 class="mat-h1">{{eventoUnidad.evento.nombre}}</h4>
            </div>
            <span class="spacer"></span>
            <ng-container *ngIf="eventoUnidad.evento.categoriaID == 81">
                <div id="classroomshare"></div>
            </ng-container>
        </div>
        <div class="evento-adicionales">
            <div class="evento-adicionales__items" style="position: relative"
                 *ngIf="eventoUnidad.eventoMaterias.length > 0">
                <mat-icon matTooltip="Eventos de aprendizaje" style="margin-top: 8px; margin-right: 8px;">info_outline
                </mat-icon>
                <ul style="width: 100%;">
                    <li *ngFor="let eventoMateria of eventoUnidad.eventoMaterias"
                        [ngClass]="{'color-green': eventoMateria.isCompletado}">
                        <div class="evento-adicionales__data">
                            <span>{{eventoMateria.nombre}}</span>

                            <span class="flex-wrap">
                                <mat-icon class="md-14">calendar_today</mat-icon>
                                {{eventoMateria.fechaAplicar | date: 'dd MMM yyyy'}}</span>
                            <span class="flex-wrap">
                                <mat-icon class="md-14">timelapse</mat-icon>
                                {{eventoMateria.duracion}} min</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div *ngIf="eventoUnidad.metas.length > 0" class="evento-adicionales__items">
                <i class="material-icons" matTooltip="Metas conectadas">link</i>
                <ul>
                    <li *ngFor="let metaConectada of eventoUnidad.metas" class="evento-meta-conectada">
                        {{metaConectada.codigo}}-{{metaConectada.id}}
                    </li>
                </ul>
            </div>
            <div *ngIf="eventoUnidad.recursos.length > 0" class="evento-adicionales__items">
                <i class="material-icons" matTooltip="Recursos">attachment</i>
                <ul>
                    <li class="evento-recurso" *ngFor="let recurso of eventoUnidad.recursos">
                        <a href="{{recurso.url}}" target="_blank">
                            <span [ngStyle]="{'color': recurso.isVisibleToStudent ? 'green' : 'inherit'}">
                                {{recurso.nombre}}
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="evento-resumen">
            <div [innerHtml]="eventoUnidad.evento.resumen"></div>
        </div>
    </div>
    <mat-dialog-actions class="actions-bar">
        <button mat-raised-button mat-dialog-close color="primary">Cerrar</button>
    </mat-dialog-actions>
</ng-container>